<template>
	<section class="view-ui-callout-media">
		<header>
			<h3 class="title">{{ title }}</h3>
			<p class="subtitle">
				{{ subtitle }}
			</p>
		</header>

		<section class="body">
			<picture>
				<img class="rounded-large" v-bind:src="imageUrl" />
			</picture>
		</section>

		<section class="action-bar button-group push-top" v-if="action">
			<button class="button-primary" v-on:click="Handle_OnClickAction">{{ action }}</button>
		</section>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, bind, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/Callout
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiCalloutMedia extends ViewBase {
		/**
		 * Action event name
		 *
		 * @type string
		 */
		@Prop()
		public action!: string;

		/**
		 * Image URL for the callout
		 *
		 * @type string
		 */
		@Prop()
		public imageUrl!: string;

		/**
		 * Subtitle of the callout
		 *
		 * @type string
		 */
		@Prop()
		public subtitle!: string;

		/**
		 * Title of the callout
		 *
		 * @type string
		 */
		@Prop()
		public title!: string;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @return Promise<void>
		 */
		@bind
		protected async Handle_OnClickAction(e: Event): Promise<void> {
			this.$emit('action');
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-ui-callout-media {
		header {
			text-align: center;
		}

		.subtitle {
			color: var(--chalky-grey-2);
			margin: 0.25rem auto 0 auto;
			max-width: 275px;
		}

		.body {
			margin-top: 1rem;
		}
	}
</style>
